import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card as RBCard } from "react-bootstrap";
import {
  Box,
  Container,
  Typography,
} from "@mui/material";
import "../../Commonmodel/Common.css";
import NationalCards from './NationalCards/NationalCards';
import IndiaMap from './IndiaMap/IndiaMap';
import StatewiseStats from './StatewiseStats/StatewiseStats';
import { CommonContext } from "../../../context/CommonContext";
import { authHttp } from '../../../services/commonHttpService';
import { apisPath } from "../../../utils/path";

const AdminDashboard = () => {
  const { setIsLoading, setSnackState } = useContext(CommonContext);

  const [nationalData, setNationalData] = useState([]);
  const [stateWiseData, setStateWiseData] = useState([]);
  const [selectedState, setSelectedState] = useState(null);

  // Helper function to transform API array to simple object
  const transformNationalData = (dataArray) => {
    const transformed = {};
    dataArray.forEach(item => {
      transformed[item?.indicator_key] = item?.indicator_value;
    });
    return transformed;
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        fetchNationalData(),
        fetchStateWiseData()
      ]);
    } catch (err) {
      // Error handling is already done in individual functions
    } finally {
      setIsLoading(false);
    }
  };

  const fetchNationalData = async () => {
    try {
      const res = await authHttp.get(`${apisPath?.adminDashboard}?type=NATIONAL`);
      if (res?.data?.status) {
        const transformed = transformNationalData(res?.data?.data);
        setNationalData(transformed);
      }
    } catch (err) {
      setSnackState({
        open: true,
        message: err?.response?.data?.message || "Failed to fetch national data",
        severity: "error",
      });
    }
  };

  const fetchStateWiseData = async () => {
    try {
      const res = await authHttp.get(`${apisPath?.adminDashboard}?type=STATEWISE`);
      if (res?.data?.status) {
        const states = res?.data?.data;
        setStateWiseData(states);

        const stateWithMaxPatients = states.reduce((max, state) =>
          state?.total_patients > max?.total_patients ? state : max
          , states[0]);

        setSelectedState(stateWithMaxPatients);
      }
    } catch (err) {
      setSnackState({
        open: true,
        message: err?.response?.data?.message || "Failed to fetch state-wise data",
        severity: "error",
      });
    }
  };

  const handleStateSelect = (stateLgd) => {
    const state = stateWiseData.find(s => s?.state_lgd === stateLgd);
    if (state) {
      setSelectedState(state);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#FFFFFF",
          borderBottom: "1px solid #E6E6E6", // light grey line
          py: 2,
        }}
      >
        <Container>
          {/* Title */}
          <Typography variant="h6" fontWeight="600">
            Day Care Cancer Center
          </Typography>

          {/* Subtitle */}
          <Typography variant="body2" color="gray" sx={{ mt: 0.3 }}>
            National Cancer Care Program - Comprehensive Overview
          </Typography>
        </Container>
      </Box>
      <Container>
        <Typography variant="h6" fontWeight={600} className="mt-3">
          Nation-Wise Overview
        </Typography>

        {/* -------- TOP CARDS -------- */}
        <NationalCards data={nationalData} stateWiseData={stateWiseData} />

        {/* -------- CENTER + RIGHT PANEL -------- */}
        <Row className="mt-4">
          {/* Map removed */}
          <Col lg={8} className="mb-3">
            <IndiaMap
              stateWiseData={stateWiseData}
              selectedState={selectedState}
              onStateSelect={handleStateSelect}
            />
          </Col>

          {/* RIGHT SIDE PANEL */}
          <Col lg={4}>
            <StatewiseStats selectedState={selectedState} />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default AdminDashboard